import { useState } from 'react';
import { styled } from '@mui/material/styles';
import { Box, Button, Grid, Typography } from '@mui/material';
import { useCommonTranslation } from '../../../../hooks/useCommonTranslation';
import { useAppSelector } from '../../../../hooks/useAppSelector';
import * as lookupSlice from '../../../../data/lookup.slice';
import clientUtils from '../../../../services/clientUtils';
import { ClientSetting } from '../../../../data/models/client-settings.model';
import ClientPreferencesDialog from './ClientPreferencesDialog';
const PREFIX = 'ClientPreferences';
const classes = {
  container: `${PREFIX}-container`,
  actions: `${PREFIX}-actions`,
  label: `${PREFIX}-label`,
  value: `${PREFIX}-value`,
};
const StyledBox = styled(Box)(({ theme }) => ({
  [`&.${classes.container}`]: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  [`& .${classes.actions}`]: {
    marginTop: theme.spacing(2),
    display: 'flex',
    alignItems: 'left',
  },
  [`& .${classes.label}`]: {
    fontWeight: 300,
  },
  [`& .${classes.value}`]: {
    fontWeight: 500,
  },
}));
interface LabelValueProps {
  label: string;
  value: string | number | undefined;
}
function LabelValue({ label, value }: LabelValueProps) {
  return (
    <Box component="div">
      <Typography component="div" className={classes.label}>
        {label}
      </Typography>
      <Typography component="div" className={classes.value}>
        {value}
      </Typography>
    </Box>
  );
}
interface ClientPreferencesProps {
  clientBC: string;
  preferences: ClientSetting[] | null;
}
export default function ClientPreferences({
  clientBC,
  preferences,
}: ClientPreferencesProps) {
  const t = useCommonTranslation();
  const clientSettingOptions = useAppSelector(
    lookupSlice.selectClientSettingOptions,
  );
  const [dialogOpen, setDialogOpen] = useState(false);
  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  return (
    <StyledBox className={classes.container}>
      <Grid container spacing={2}>
        <Grid item lg={3} md={6} sm={12}>
          <LabelValue
            label={t('client.defaultPickupTime')}
            value={`${clientUtils.getPickUpTimeOffsetMinutes(clientSettingOptions, preferences)} ${t('client.priorToAppointment')}`}
          />
        </Grid>
      </Grid>
      <Box className={classes.actions}>
        <Button
          variant="contained"
          color="primary"
          onClick={() => setDialogOpen(true)}>
          {t('common.edit')}
        </Button>
      </Box>
      <ClientPreferencesDialog
        clientBC={clientBC}
        open={dialogOpen}
        close={handleDialogClose}
        preferences={preferences}
      />
    </StyledBox>
  );
}
